import type { CompleteStylistFragment } from '@drycut/graphql';

import { Button, Para, Stack } from '@drycut/ui-components';
import { CheckCircleIcon } from '@heroicons/react/20/solid';
import { twMerge } from 'tailwind-merge';

type Props = {
  onSelect: (stylist: CompleteStylistFragment) => void;
  selected: boolean;
  stylist: CompleteStylistFragment;
};

export default function StylistCheckInCard({
  stylist,
  onSelect,
  selected,
}: Props): React.ReactElement {
  const iconClasses = twMerge(
    'size-6 border border-primary-200 ',
    selected
      ? 'text-primary-600 group-hover:text-white group-hover:border-white border-primary-600'
      : 'text-white bg-white ',
    'rounded-full',
  );
  const buttonClasses = twMerge(
    'group bg-zinc-100 p-4 shadow-sm border border-primary-200 text-primary-600/80 hover:text-white',
    selected ? 'bg-primary-600/30 text-primary-600 border-primary-600' : '',
  );

  return (
    <Button onClick={() => onSelect(stylist)} className={buttonClasses}>
      <Stack direction="row" className="w-full justify-between group">
        <CheckCircleIcon className={iconClasses} />
        <Para className="grow text-primary-600 group-hover:text-primary-100" weight="bold">
          {stylist.name}
        </Para>
      </Stack>
    </Button>
  );
}
